<template>
  <div>
    <el-select placeholder="请选择" size='small' v-model="category_id_" clearable >
      <el-option v-for="(v,i) in list" :value="v.id" :key='v.id' :label="v.name" >
        <span v-for="(vv,ii) in (v.lv-1)" :key='"tip_"+ii'>&#12288;&#12288;</span> <span v-if="v.lv!=1">├</span>{{v.name}}
      </el-option>

    </el-select>


  </div>

</template>

<script>
  export default {
    name: "Category",
    data() {
      return {
        category_id_: this.category_id,
        list: []
      }
    },
    methods: {

      getCategoryList() {

        this.httpPost({
          url: "/admin/common/getCategoryListV2",
          data:{id:this.pid}
        }).then((re) => {

          console.log(re);

          this.list = re.data;

        });

      }

    },
    created() {

      this.getCategoryList();

    },
    computed: {

    },
    props: {

      category_id: {
        type: [Number,String],
        default: ''
      },
      pid:{
        type:[Number,String],
        default:0

      }

    },
    watch: {

      category_id(value) {

        this.category_id_ = value;

      },
      category_id_(value){

        this.$emit('update:category_id',value);

      },


    }

  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/Category.vue